// extracted by mini-css-extract-plugin
export var alert = "gamesPrepare-module--alert--8emAH";
export var btn = "gamesPrepare-module--btn--1lllm";
export var alertLogo = "gamesPrepare-module--alertLogo--TQF5F";
export var copyright = "gamesPrepare-module--copyright--umRld";